<template>
  <div class="page-wrapper">
    <section class="full-section">
      <div class="container">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-md-8 col-lg-6 position-relative">
            <div class="signup-logo d-flex justify-content-center">
              <logo :height="34"></logo>
            </div>
            <signup-track></signup-track>
            <signup-form></signup-form>
          </div>
        </div>
      </div>
    </section>
    <div class="bottom-mountains">
      <img src="@/assets/mountains-bg.png" alt />
    </div>
  </div>
</template>

<script>
import Logo from '../components/header/Logo.vue'
import SignupForm from '@/components/SignupForm.vue'
import SignupTrack from '@/components/SignupTrack.vue'

export default {
  components: {
    logo: Logo,
    'signup-form': SignupForm,
    'signup-track': SignupTrack
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('setSignupFinished', true)
    this.$store.commit('setSignupStep', 1)
    next()
  }
}
</script>
